import { combineReducers } from 'redux';
import profile from './profile';
import companies from './companies';
import bookings from './bookings';
import integrations from './integrations';

export default combineReducers({
  profile,
  companies,
  bookings,
  integrations
});



// WEBPACK FOOTER //
// ./src/reducers/profile/index.js